import { render } from "./DownloadPhone.vue?vue&type=template&id=3804580f&scoped=true"
import script from "./DownloadPhone.vue?vue&type=script&lang=js"
export * from "./DownloadPhone.vue?vue&type=script&lang=js"

import "./DownloadPhone.vue?vue&type=style&index=0&id=3804580f&lang=scss&scoped=true"

import exportComponent from "/Users/smzdm/Desktop/前端项目/畅效官网/cx_official_website/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3804580f"]])

export default __exports__